export default __webpack_public_path__ + "static/media/Mark-6-HUD-Pop-Up (Phone Call).e374a0d7.jpg";